import PriceInput from './PriceInput.vue'

export default PriceInput